/**
 * Shares one camera blob per frame between a producer Preview (captures from hardware)
 * and consumer Previews (reuse the blob with their own L2/L3 crop). Eliminates duplicate
 * capturePreview calls when multiple live previews show the same camera (e.g. frame-strip).
 */

export const PREVIEW_CAPTURE_SHARE_FRAME_STRIP = 'frame-strip' as const

export type PreviewCaptureShareGroupId = typeof PREVIEW_CAPTURE_SHARE_FRAME_STRIP

export type CameraKey = 'primary' | 'secondary'

export type SharedPreviewCaptureFrame = {
  seq: number
  blob: Blob
  originalWidth: number
  originalHeight: number
  cameraKey: CameraKey
}

const stores = new Map<PreviewCaptureShareGroupId, SharedPreviewCaptureFrame>()

let seqCounter = 0

export function publishSharedPreviewCapture(
  groupId: PreviewCaptureShareGroupId,
  cameraKey: CameraKey,
  blob: Blob,
  originalWidth: number,
  originalHeight: number
): void {
  seqCounter += 1
  stores.set(groupId, {
    seq: seqCounter,
    blob,
    originalWidth,
    originalHeight,
    cameraKey
  })
}

export function peekSharedPreviewCapture(
  groupId: PreviewCaptureShareGroupId
): SharedPreviewCaptureFrame | undefined {
  return stores.get(groupId)
}

export function clearSharedPreviewCapture(groupId: PreviewCaptureShareGroupId): void {
  stores.delete(groupId)
}
